<div class="content_container">
    <div class="logo_container">
      <a routerLink="/">
        <img src="../../../assets/AMADEO LOGO 2.png" class="logo">
      </a>
    </div>
    <div *ngIf="type == loginTypes.LOGIN" class="page_title login">{{ loginName }}</div>
    <div *ngIf="type == loginTypes.ACCESS_CONTROL_LOGIN" class="page_title access_control">{{ loginName }}</div>
    <div *ngIf="type == loginTypes.HOSPITALITY_LOGIN" class="page_title hospitality">{{ loginName }}</div>
    <div *ngIf="type == loginTypes.SKYACCESS_LOGIN" class="page_title skyaccess">{{ loginName }}</div>
    <div *ngIf="type == loginTypes.FREELEX_LOGIN" class="page_title freelex">{{ loginName }}</div>
    <div *ngIf="type == loginTypes.HEALTH_CARE" class="page_title healthcare">{{ loginName }}</div>
    <div *ngIf="type == loginTypes.HOME_MONITORING" class="page_title home_monitoring">{{ loginName }}</div>
    <div *ngIf="type == loginTypes.GREEN_BUILDING" class="page_title green_building">{{ loginName }}</div>
    <div *ngIf="type == loginTypes.PARKING" class="page_title parking">{{ loginName }}</div>
    <div *ngIf="type == loginTypes.TIME_ATTENDANCE" class="page_title time_attendance">{{ loginName }}</div>
    <div *ngIf="type == loginTypes.EVENT_TICKETING" class="page_title event_ticketing">{{ loginName }}</div>

    <div class="form_container">
        <form>
          <div class="form-group">
            <label for="username">Username</label>
            <input type="text" class="form-control" id="username">
          </div>
            <div class="form-group">
              <label for="inputPassword">Password</label>
              <input type="password" class="form-control" id="inputPassword">
            </div>
            <div class="form-group m-0">
              <div class="forgot_password">
                <a routerLink="/forgot-password">Forgot password?</a>
              </div>
            </div>
            <div class="form-group mt-3">
                <a *ngIf="type == loginTypes.LOGIN" routerLink="/unavailable" class="btn btn-success pull-right btn-block enter_btn">Enter</a>
                <a *ngIf="type == loginTypes.ACCESS_CONTROL_LOGIN" href="https://sandbox-integracloud.skyaccess.eu/IACloud-Platform/dashboard/default" class="btn btn-success btn-block enter_btn">Enter</a>
                <a *ngIf="type == loginTypes.HOSPITALITY_LOGIN" href="https://sandbox-integracloud.skyaccess.eu/IACloud-Platform/dashboard/crm" class="btn btn-success btn-block enter_btn">Enter</a>
                <a *ngIf="type == loginTypes.SKYACCESS_LOGIN" href="https://sandbox-integracloud.skyaccess.eu/IACloud-Platform/skyaccess/hotel" class="btn btn-success btn-block enter_btn">Enter</a>
                <a *ngIf="type == loginTypes.FREELEX_LOGIN" routerLink="/unavailable" class="btn btn-success btn-block enter_btn">Enter</a>
                <a *ngIf="type == loginTypes.HEALTH_CARE" href="https://sandbox-integracloud.skyaccess.eu" class="btn btn-success btn-block enter_btn">Enter</a>
                <a *ngIf="type == loginTypes.HOME_MONITORING" href="https://sandbox-integracloud.skyaccess.eu" class="btn btn-success btn-block enter_btn">Enter</a>
                <a *ngIf="type == loginTypes.GREEN_BUILDING" href="https://sandbox-integracloud.skyaccess.eu" class="btn btn-success btn-block enter_btn">Enter</a>
                <a *ngIf="type == loginTypes.PARKING" href="https://sandbox-integracloud.skyaccess.eu" class="btn btn-success btn-block enter_btn">Enter</a>
                <a *ngIf="type == loginTypes.TIME_ATTENDANCE" href="https://sandbox-integracloud.skyaccess.eu" class="btn btn-success btn-block enter_btn">Enter</a>
                <a *ngIf="type == loginTypes.EVENT_TICKETING" href="https://sandbox-integracloud.skyaccess.eu" class="btn btn-success btn-block enter_btn">Enter</a>

            </div>
          </form>
    </div>


    <!-- <a href="https://www.skyaccess.eu/IACloud-Platform/dashboard/default" class="no_display" #accessControlLogin>access</a>
    <a href="https://www.skyaccess.eu/IACloud-Platform/dashboard/crm" class="no_display" #hospitalityLogin>hospi</a>
    <a href="https://www.skyaccess.eu/IACloud-Platform/skyaccess/hotel" class="no_display" #skyAccessLogin>access</a> -->
</div>
